/* globals addQueryParam, getNextDays, updateEventBind, dateMidpoint, getTimeRange */
/* The MIT License
 *
 * Copyright (c) 2013, Sebastian Sdorra
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

(function () {
	'use strict';

	angular.module('widgets.buyer')
		.controller('genericBuyerTblCtrl', genericBuyerTblCtrl);

	function genericBuyerTblCtrl($rootScope, $scope, $filter, $timeout, $http, $q, $experiments, config, hostUrl, getJsonData,
			title, type, currencyFormatService, numberFormatService, integerFormatService,
			dashboardFilterInitializationService, pageTimingService, leanFilterService, storeService, buyerWidgetsService, drilldownFunctionsService) {

		if (!$scope.$parent.content.defaultDrillDownUrl) {
			$scope.$parent.content.defaultDrillDownUrl = $scope.$parent.content.drillDownUrl;
		}

		var iconMap = buyerWidgetsService.getTaskIcons();
		var iconTip = buyerWidgetsService.getTaskTooltips();
		var itemCtrlDivEl = angular.element(document.getElementById('itemCtrlDiv'));
		$scope.openModal = itemCtrlDivEl.scope().openModal;
		$scope.isPastDue = function(date) {
			return moment.utc().startOf('day').diff(moment.utc(date).startOf('day'), 'days') >= 0;
		};

		$scope.chartId = type;
		$scope.chartTitle = title;
		$scope.data = [];
		$scope.count = 0;
		$scope.empty = true;
		$scope.loading = true;
		$scope.loadingTable = false; // to add an individual loading spinner for the table ajax call
		$scope.settings = {};
		$scope.isReadOnly = storeService.getState().reportSettings.readOnly;
		var chartProps = tablularWidgetProperties[$scope.chartId]; //load chart properties by chart type
		$scope.drilldownDefaultTabs = chartProps.drilldownDefaultTabs;
		$scope.addnlLabelText = chartProps.addnlLabelText;
		var services = {
			'currencyFormatService': currencyFormatService,
			'numberFormatService': numberFormatService,
			'integerFormatService': integerFormatService
		};
		var fmtService = services[chartProps.fmtService];

		if (chartProps.defaultTab) {
			$scope.settings.activeTab = chartProps.defaultTab;
		}

		for (var settingName in config.settings) {
			if (config.settings.hasOwnProperty(settingName)) {
				$scope.settings[settingName] = config.settings[settingName];
			}
		}
		$scope.slideshowView = $rootScope.slideshowView;

		this.checked = true;
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;
		$scope.$parent.$parent.showViewReport = false;
		var reactDrilldownUrl = $scope.$parent.content.reactDrilldownUrl;
		var reactDrilldownExperiment = $scope.$parent.content.reactDrilldownExperiment;
		var useReactDrilldown = reactDrilldownUrl && (reactDrilldownExperiment ? $experiments.isEnabled(reactDrilldownExperiment) : true);

		$scope.setActiveTab = function(activeTab) {
			var widget = $scope.$parent.model;
			if (!widget.config.settings) {
				widget.config.settings = {'activeTab': activeTab};
			}
		};

		$scope.saveWidgetSettings = function(doNotReload) {
			// save config
			var widget = $scope.$parent.model;
			widget.config.settings = $scope.settings;
			var newSetting;
			if (widget.config.settings.activeTab) {
				newSetting = widget.config.settings.activeTab;
			} else {
				newSetting = 'UNKNOWN_WIDGET_SETTING';
			}
			pendo.track('widgetChangeConfig', {
				widgetType: widget.config.type,
				mode: newSetting
			});
			if (!$scope.isReadOnly) {
				var columnDefinition = $scope.$parent.$parent.col;
				storeService.dispatch({
					type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
					payload: {
						column: 'column' + columnDefinition.columnIndex,
						position: columnDefinition.widgets.indexOf(widget),
						widget: {
							name: widget.config.type,
							config: _.cloneDeep(widget.config)
						}
					},
					meta: {
						reportName: undefined,
						reportSettingsId: globalReportName
					}
				});
			}

			if (!doNotReload) {
				loadData();
			}
		};

		$scope.mapIcons = function () {
			angular.forEach($scope.data.data, function (row) {
				if (row.actionStatus) {
					row.actionStatusIcon = iconMap[row.actionStatus];
					row.actionStatusTip = iconTip[row.actionStatus];
				} else {
					row.actionStatusIcon = 'fa-lightbulb-o';
					row.actionStatusTip = 'No Task, click to add task';
				}
			});
		};

		$scope.generateTableParams = function(sortParams, d) {
			$scope.empty = !d.data.length;
			if (!$scope.empty) {
				$scope.data = d;
				angular.forEach(sortParams, function(sortDir, sortCol) {
					$scope.sortDirection = sortDir;
				});
			}
		};

		$scope.setDrilldownUrl = function() {
			if ($scope.$parent.content.isNewDrillDown) {
				// New drill down report support multiselect.
				var filtersObj = $scope.drilldownQueryParams;
				filtersObj['taskStatus'] = ['Open'];
				if ($scope.$parent.content.useFactoryFilter) {
					filtersObj['factory'] = $scope.leanFilterService.getFactoryList();
					filtersObj['businessunit'] = $scope.filterService.getSelected('Business Unit');
				}
				filtersObj = _.omit(filtersObj, $scope.$parent.content.ignoreFilters);

				if (useReactDrilldown) {
					var filters = $scope.$parent.content.reactDrilldownFilters;
					if ($scope.$parent.model.config.settings.activeTab === 'myTasks') {
						filters.push({ id: 'responsibleNdx', values: [globalConfig.user.id] });
					} else {
						filters = filters.filter(function(filterObj) {
							return filterObj.id !== 'responsibleNdx';
						});
					}
					var sorters = $scope.$parent.content.reactDrilldownSorters;
					$scope.$parent.content.drillDownUrl = reactDrilldownUrl + drilldownFunctionsService.makeDrilldownParamString(filters, true, sorters, false);
					$scope.$parent.$parent.showViewReport = true;
					$scope.viewAllLink = $scope.$parent.content.drillDownUrl;
				} else {
					
					$timeout(function() {
						$scope.$parent.content.drillDownUrl = addQueryParam(
							$scope.$parent.content.defaultDrillDownUrl, null, filtersObj, false);
						$scope.$parent.$parent.showViewReport = true;
						$scope.viewAllLink = $scope.$parent.content.drillDownUrl;
					}, 0);
				}
			} else {
				filtersObj = $scope.drilldownQueryParams;
				filtersObj['taskStatus'] = ['Open'];
				$scope.$parent.content.drillDownUrl = addQueryParam(
					$scope.$parent.content.drillDownUrl, null, filtersObj, true);
				$scope.$parent.$parent.showViewReport = true;
				$scope.viewAllLink = $scope.$parent.content.drillDownUrl;
			}
		};

		$scope.$on('updateRows', function (event, args) {
			if ($scope.data && $scope.data.data) {
				_.map(_.filter($scope.data.data, args.identifier), function (row) {
					for (var key in args.newValues) {
						row[key] = args.newValues[key];
					}

					if (row.actionStatus && row.actionStatus === 'Archived') {
						delete row.actionStatus;
						delete row.taskId;
					}
				});
				$scope.mapIcons();
			}
		});

		function getTable() {
			$scope.drilldownQueryParams = $scope.leanFilterService.getQueryParamsObject(true, true);
			if (!_.isObject(tablularWidgetProperties[type].tableUrl)) {
				$scope.setDrilldownUrl();
			}

			if (tablularWidgetProperties[type].tableUrl) {
				var queryParams = $scope.leanFilterService.getQueryParamsObject(true);
				queryParams['specialFlag1'] = chartProps.spclFlag1;
				queryParams['taskStatus'] = ['Open'];
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (typeof tablularWidgetProperties[type].getTableUrlParams === 'function') {
					_.assign(queryParams, tablularWidgetProperties[type].getTableUrlParams($scope, tablularWidgetProperties[type]));
				}
				if (_.isObject(tablularWidgetProperties[type].tableUrl)) {
					var promises = [];
					var responseList = [];
					var tabs = [];
					angular.forEach(tablularWidgetProperties[type].tableUrl, function (value, key) {
						if (tablularWidgetProperties[type].getPromises) {
							promises = _.concat(promises, tablularWidgetProperties[type].getPromises($http, hostUrl, value, key, $scope.leanFilterService));
						} else {
							if (chartProps.spclFlag1 && chartProps.spclFlag1[key]) {
								queryParams['specialFlag1'] = chartProps.spclFlag1[key];
							} else {
								queryParams['specialFlag1'] = 'none';
							}
							var queryParamObject = _.omit(queryParams, chartProps.ignoreFilters[key]);
							promises.push($http.get(hostUrl + addQueryParam(value,
								$scope.leanFilterService.getFactoryList(), queryParamObject, false)));
						}
						tabs.push(key);
					});
					$q.all(promises).then(function (result) {
						angular.forEach(result, function (response, index) {
							responseList[index] = response.data;
						});
						if (chartProps.dataFunction) {
							chartProps.dataFunction($scope, responseList, tabs, currencyFormatService);
						}
					}, function(error) {
						if (chartProps.dataFunction) {
							responseList = [];
							angular.forEach(tabs, function (tab) {
								responseList.push('');
							});
							chartProps.dataFunction($scope, responseList, tabs, currencyFormatService);
						}
					});
				} else {
					var queryParamObject = _.omit(queryParams, $scope.$parent.content.ignoreFilters);
					var url = addQueryParam(tablularWidgetProperties[type].tableUrl,
						$scope.leanFilterService.getFactoryList(), queryParamObject, false);
					getJsonData.get(hostUrl + url).then(
						function (d) {
							$scope.data = d;
							$scope.totalRows = d.count;
							$scope.empty = false;
							$scope.loading = false;
							$scope.formatCurrency = function(amount) {
								return currencyFormatService.getWithParameters(amount, 0, d.targetCurrencySymbol);
							};
							$scope.mapIcons();
							$scope.generateTableParams(chartProps.sortParms, d);
							if (!$scope.slideshowView) {
								pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
							}
						},
						function (e) {
							$scope.empty = true;
							$scope.loading = false;
							if (!$scope.slideshowView) {
								pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
							}
						}
					);
				}

			}
		}

		$scope.itemBelongsToCurrentFactory = function () {
			return (parseInt(globalConfig.factory.id) === this.row.ldfNdx);
		};

		$scope.getTooltipForItemInDifferentFactory = function () {
			return 'Change to ' + this.row.factoryName + ' to view item.';
		};

		updateEventBind($scope, ['sideBarUpdate', 'slideshowViewChanged', 'inventoryFilterChanged']);

		var loadData = function () {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				getTable();
			} else {
				$timeout(loadData, 100);
			}
		};
		
		loadData();
	}
})();
